<template>
    <div>
        <div id="app">
            <v-app id="inspire">
                <div class="spinner-wrapper">
                    <div class="spinner">
                        <div class="rect1" />
                        <div class="rect2" />
                        <div class="rect3" />
                        <div class="rect4" />
                        <div class="rect5" />
                    </div>
                </div>

                <v-navigation-drawer v-model="drawer" class="colorSidebar no-print" dark fixed clipped app>
                    <v-list dense>
                        <v-list-tile class="singleMenuItem" @click="navigate('/dashboard')">
                            <v-list-tile-action class="singleMenuIcon">
                                <v-icon ref="/dashboardIcon" class="myMenuIcon">fas fa-home fa-sm</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content ref="/dashboard">
                                <v-list-tile-title class="singleSideBarTitle">
                                    Dashboard
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>

                        <div v-for="(value, key, index) in MenuList" :key="'menu'+index">
                            <v-list-group v-if="checkIsDisplay(value)" class="menuGroup" :size="'10px'" :prepend-icon="value.Icon">
                                <v-list-tile slot="activator">
                                    <v-list-tile-title :ref="key" class="primarySideBarTitle">{{ key }}</v-list-tile-title>
                                </v-list-tile>

                                <v-list-tile v-for="formItem in value.List" :key="formItem.text" :href="formItem.path" class="sideBarItem" @click.prevent="navigate(formItem.path, 'formItem')">
                                    <v-list-tile-action>
                                        <v-icon>{{ formItem.icon }}</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content :ref="formItem.path">
                                        <v-list-tile-title class="secondarySideBarTitle">
                                            {{ formItem.text }}
                                            <div class="availableChipDiv">
                                                <div v-if="formItem.isAvailable" class="availableTickChip"><i class="fas fa-check flex-margin-auto" /></div>
                                            </div>
                                            <!-- <v-chip  color="red" text-color="white" class="availableChip"></v-chip> -->
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list-group>
                        </div>

                        <v-list-tile class="singleMenuItem" @click="navigate('/glossary')">
                            <v-list-tile-action class="singleMenuIcon">
                                <v-icon ref="/glossaryIcon" class="myMenuIcon">fas fa-book</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content ref="/glossary">
                                <v-list-tile-title class="singleSideBarTitle">
                                    Glossary Menu
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>

                    <div class="versionDiv">
                        <div class="powerByDiv">
                            <p class="powerByText">Powered by </p>
                            <img class="powerByArginomeLogo" src="@/assets/images/agrinome_logo/agrinome_logo_white.png" alt="agrinome logo">
                        </div>
                        <!-- <p class="gitHash"> version: {{shortenHash()}}</p> -->
                        <!-- <p class="gitHash"> {{getVersion()}} - {{shortenHash()}}</p> -->
                    </div>
                </v-navigation-drawer>

                <v-toolbar class="no-print headerBar" dark fixed clipped-left app>
                    <v-toolbar-side-icon @click.stop="drawer = !drawer" />
                    <v-toolbar-title class="mr-5 align-center">
                        <!-- <img class="mpobLogo" src="@/assets/images/mpob_white.png" alt="mpob logo">&nbsp;&nbsp; -->
                        <router-link to="/dashboard"><img class="arginomeLogo" src="@/assets/images/agrinome_logo/agrinome_logo_white.png" alt="agrinome logo"></router-link>
                    </v-toolbar-title>

                    <v-spacer />

                    <transition name="fade">
                        <div v-show="isSearchField" class="searchDiv">
                            <input v-model="query" class="searchField form-control form-control-sm" type="text" placeholder="Search..." @keyup.enter="globalSearch()">
                        </div>
                    </transition>

                    <v-btn v-show="!isSearchField" icon dark @click="isSearchField=true">
                        <span class="dropdownIcon"><i class="fas fa-search" /></span>
                    </v-btn>

                    <v-btn icon dark @click="clearCache()">
                        <span class="dropdownIcon"> <i class="fas fa-redo-alt" /></span>
                    </v-btn>

                    <el-dropdown size="small">
                        <el-button type="primary" size="mini">
                            {{ userName }}<i class="el-icon-arrow-down el-icon--right" />
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="$_navigateTo('MyProfile')">My Profile</el-dropdown-item>
                            <el-dropdown-item v-for="(list, index) in AdvanceList" :key="'advance'+index" 
                                              v-permission="list.PermissionName"
                                              @click.native="$_navigateTo(list.path)"
                            >
                                {{ list.text }}
                            </el-dropdown-item>
                            <el-dropdown-item divided @click.native="logOut()">Logout</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </v-toolbar>

                <v-content>
                    <v-container fill-height>
                        <v-layout justify-center>
                            <v-flex>
                                <delete-dialog />
                                <router-view />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-content>
            </v-app>
        </div>
        <!-- 		<NavBar></NavBar>
-->
    </div>
</template>
<script>
import HASH from "raw-loader!@/assets/gitCommitHash.txt"; //Need to install raw-loader
import NotificationIcon from "@/components/Notification/NotificationIcon";
import InfomationSidebar from "@/components/InfomationSidebar";
import { mapGetters } from "vuex";

export default {
    name: "Base",
    components: {
        "notification": NotificationIcon,
        "infomation-sidebar": InfomationSidebar,
    },
    data() {
        return {
            drawer: true,

            query: "",

            userName: "",
            userNameFirst: "",

            isSearchField: false,

            MenuList: {
                Action: {
                    Icon: "cloud_upload",
                    Permission: true,
                    PermissionName: "",
                    List: [
                        { icon: "", text: "Import Experiment", path_front: "batch-upload", path: "/import-experiment" },
                        { icon: "", text: "Import Raw Data ", path_front: "batch-upload", path: "/import-raw-data" },
                        { icon: "", text: "Import Derived Data ", path_front: "batch-upload", path: "/import-derived-data" },
                        { icon: "", text: "Import Status", path_front: "batch-upload", path: "/import-status" },
                        { icon: "", text: "Input Raw Data", path_front: "form-input", path: "/input-raw-data" },
                    ],
                },
                Listing: {
                    Icon: "format_list_bulleted",
                    Permission: true,
                    PermissionName: "",
                    List: [
                        { icon: "", text: "Programme List", path_front: "programme", path: "/programme/programme-list" },
                        { icon: "", text: "Trial List", path_front: "trial", path: "/trial/trial-list" },
                        { icon: "", text: "Progeny List", path_front: "progeny", path: "/progeny/progeny-list" },		
                        { icon: "", text: "Palm List", path_front: "palm", path: "/palm/palm-list" },
                        { icon: "", text: "Agency List", path_front: "agency", path: "/agency/agency-list" },
                        { icon: "", text: "Germplasm List", path_front: "germplasm", path: "/germplasm/germplasm-list/all" },
                    ],
                },
                "Raw Data": {
                    Icon: "view_list",
                    Permission: true,
                    PermissionName: "",
                    List: [
                        { icon: "", text: "Bunch Data", path_front: "bunch", path: "/raw/bunch-data-list" },
                        { icon: "", text: "Carotene Data", path_front: "carotene", path: "/raw/carotene-data-list" },
                        { icon: "", text: "Fatty Acid Data", path_front: "fatty-acid", path: "/raw/fatty-acid-data-list" },
                        { icon: "", text: "Vegetative Data", path_front: "vegetative", path: "/raw/vegetative-list" },
                        { icon: "", text: "Vitamin E Data", path_front: "vitamin", path: "/raw/vitamin-list" },
                        { icon: "", text: "Yield Data", path_front: "yield", path: "/raw/yield-data-list" },
                    ],
                },
                "Derived Data": {
                    Icon: "view_comfy",
                    Permission: true,
                    PermissionName: "",
                    List: [
                        { icon: "", text: "Bunch Data", path_front: "bunch", path: "/derived/bunch-data-list" },
                        { icon: "", text: "Vegetative Data", path_front: "vegetative", path: "/derived/vegetative-list" },
                        { icon: "", text: "Yield Data", path_front: "yield", path: "/derived/yield-data-list" },
                    ],
                },
                Inventory: {
                    Icon: "account_balance",
                    Permission: true,
                    List: [
                        { icon: "", text: "Fresh Seed Bags", path_front: "fresh-seed-bag-list", path: "/fresh-seed-bag-list" },
                        { icon: "", text: "Seed Transaction", path_front: "seed-transaction", path: "/seed-transaction" }
                    ],
                },
                Analytics: {
                    Icon: "graphic_eq",
                    Permission: true,
                    PermissionName: "",
                    List: [
                        { icon: "", text: "Breeding Material Selection", isAvailable: "A", path_front: "breeding-material-selection", path: "/breeding-material-selection" },
                        // { icon: '', text: 'Yield Anova', isAvailable: 'A', path_front: 'yield-anova', path: '/yield-anova-analysis' },
                        // { icon: '', text: 'Field Performance', isAvailable: '', path_front: 'field-performance', path: '/field-performance' },
                        // { icon: '', text: 'Physical Inventory', isAvailable: '', path_front: 'physical-inventory', path: '/physical-inventory' },
                        // { icon: '', text: 'Seed Inventory', isAvailable: '', path_front: 'seed-inventory', path: '/seed-inventory' },
                        // { icon: '', text: 'Germplasm Collection', isAvailable: '', path_front: 'germplasm-collection', path: '/germplasm-collection' },
                    ],
                },
                "Advance Search": {
                    Icon: "search",
                    Permission: true,
                    PermissionName: "",
                    List: [
                        { icon: "", text: "Global Search", path_front: "global-search", path: "/global-search" },
                    ],
                },
                Configurations: {
                    Icon: "settings",
                    Permission: true,
                    PermissionName: "Permissions.Breeding.Configurations",
                    List: [
                        { icon: "", text: "Analytics Configurations", path_front: "base-configuration", path: "/base-configuration" },
                        { icon: "", text: "Types Configurations", path_front: "types-configuration", path: "/types-configuration" },
                        { icon: "", text: "Others Configurations", path_front: "others-configuration", path: "/others-configuration" },
                    ],
                },
                "Seed Production": {
                    Icon: "assignment",
                    Permission: true,
                    PermissionName: "Permissions.Breeding.Configurations",
                    List: [
                        { icon: "", text: "SP Form", path_front: "seed-production-form", path: "/seed-production-form" },
                        { icon: "", text: "Bunch", path_front: "bunches", path: "/bunches" },
                    ],
                },
                "- Internal -": {
                    Icon: "accessibility",
                    Permission: true,
                    PermissionName: "Internal",
                    List: [
                        { icon: "", text: "Custom Input Raw", path_front: "form-input", path: "/input-raw-data" },
                        { icon: "", text: "Custom Raw List", path_front: "field-data", path: "/raw/other-recording" },
                        { icon: "", text: "Measurement Unit Configurations", path_front: "measurement-unit-configuration", path: "/measurement-unit-configuration" },
                        { icon: "", text: "Raw Data Flag Configurations", path_front: "raw-flag-configuration", path: "/raw-flag-configuration" },
                        { icon: "", text: "Group Flag Configurations", path_front: "group-flag-configuration", path: "/group-flag-configuration" },
                        { icon: "", text: "Custom Form Configurations", path_front: "custom-form-table", path: "/custom-form-table" },
                        { icon: "", text: "Darwin Form Configurations", path_front: "darwin-form-configuration", path: "/darwin-form-configuration" },
                    ],
                },
                Export: {
                    Icon: "get_app",
                    Permission: true,
                    PermissionName: "",
                    List: [
                        { icon: "", text: "Export Table", path_front: "export-file", path: "/export-file" },
                    ],
                }
            },
            AdvanceList: [
                { text: "Users Management", PermissionName: "Permissions.Users", Permission: true, path: "UserManagement" },
                { text: "Trial Roles Management", PermissionName: "Permissions.Breeding.TrialRoles", Permission: true, path: "TrialManagement" },
                { text: "Activity Log", PermissionName: "Permissions.Breeding.SimpleLogs", Permission: true, path: "SimpleLog" },
                { text: "System Log", PermissionName: "Permissions.Breeding.AuditLogs", Permission: true, path: "AdvanceLog" },
            ],
            advanceListCount: 0,

            gitHash: HASH,
        };
    },
    computed: {
        ...mapGetters([
            "infoSidebar",
        ])
    },
    watch: {
        "$route" (to, from) {
            this.getCurrentTouchDBVersion();
            var self = this;
            var myPath = ["/dashboard", "/glossary"];
            for (var key in this.MenuList) {
                self.MenuList[key].List.forEach(item => {
                    myPath.push(item.path);
                });
            }
            if (myPath.includes(to.path)) {
                $(".active").removeClass("active");
                if ($(this.$refs[to.path]).children(".secondarySideBarTitle").length > 0) {
                    $(this.$refs[to.path]).addClass("v-list__group__header--active");
                    $(this.$refs[to.path]).children(".secondarySideBarTitle").addClass("active");
                }
                else {
                    $(".v-list__group").removeClass("v-list__group--active");
                    $(".v-list__group__header").removeClass("v-list__group__header--active");
                    $(".v-list__group__header__prepend-icon").removeClass("primary--text");
                    $(".v-list__group__items").attr("style", "display: none");
                    $(this.$refs[to.path]).children(".singleSideBarTitle").addClass("active");
                    $(this.$refs[to.path + "Icon"]).addClass("active");
                }
            }
        },
        infoSidebar: {
            handler() {
                if (this.infoSidebar.info_sidebar) document.documentElement.style.setProperty("--sidebar-info-size", "400px");
                else document.documentElement.style.setProperty("--sidebar-info-size", "0px");
            },
            deep: true
        }
    },
    mounted() {
        // $('.active').removeClass('active');
        // $(this.$refs[this.$route.path.split("/")[1]]).addClass('active');
        // $(this.$refs[this.$route.meta.category]).click();
        this.initSignalR();
        this.getUser();
        this.setTokenIntoVuexStore();
        this.getCurrentTouchDBVersion();
    },
    methods: {
        checkIsDisplay(value) {
            if (process.env.INTERNAL && value.PermissionName == "Internal") {
                return true;
            }
            else if (value.PermissionName) {
                return PermissionService.checkPermission(value.PermissionName);
            }
            else {
                return true;
            }
        },
        navigate(link, tab) {
            window.localStorage.removeItem("globalSearchQuery");
            this.$router.push(link);
        },
        clearCache() {
            ApiConfig.removeCacheDB();
            location.reload();
        },
        logOut() {
            TokenService.removeToken();
            ApiConfig.removeCacheDB();
            this.$router.push({ name: "Login" });
        },
        setTokenIntoVuexStore() {
            let token = TokenService.getToken();
            if (token) {
                this.$store.dispatch("auth/setToken", token);
            }
        },
        getUser() {
            var self = this;
            axios({
                method: "GET",
                url: "Session/GetCurrentLoginInformations",
            })
                .then(function (response) {
                    self.userName = response.data.result.user.userName;
                    self.userNameFirst = response.data.result.user.userName.charAt(0);
                    PermissionService.savePermission(response.data.result.user.grantedPermissions);
                });
        },
        initSignalR() {
            this.$store.dispatch("signalr/initSignalR");
        },
        globalSearch() {
            window.location.hash = this.query;
            window.localStorage.setItem("globalSearchQuery", this.query);
            this.query = "";
            this.$router.push("/global-search");
        },
        getVersion() {
            return process.env.VERSION_NAME;
        },
        shortenHash() {
            return this.gitHash.substring(0,8);
        },
        getCurrentTouchDBVersion() {
            var self = this;
            self.indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.moz_indexedDB;
            self.request = indexedDB.open("AgrinomeDB");
            self.request.onerror = function(e) {
                console.log("There was an error");
            };
            self.request.onsuccess = function(event) {
                store.state.db = self.request.result;
                self.TouchDBVersion = store.state.db.version;
                window.localStorage.setItem("DBVersion", store.state.db.version);
                console.log("version", store.state.db.version);
                var countRequest = store.state.db.transaction("GlossaryLibrary", "readwrite")
                    .objectStore("GlossaryLibrary")
                    .count();
                countRequest.onsuccess = function(event) {
                    if (countRequest.result > 0) {
                        EventBus.$emit("updateGlosasry");
                        EventBus.$emit("getGlossary");
                    }
                    else {
                        axios({
                            method: "GET",
                            url: "GlossaryTerm/GetAllWithoutPaging",
                        }).then(function (response) {
                            var totalCount = response.data.result.totalCount;
                            var successWriteCount = 0;
                            response.data.result.items.forEach(item => {
                                var request = store.state.db.transaction("GlossaryLibrary", "readwrite")
                                    .objectStore("GlossaryLibrary")
                                    .add(item);
                                request.onsuccess = function (event) {
                                    successWriteCount++; 
                                    console.log("The data has been written successfully");
                                    if (totalCount == successWriteCount) {
                                        EventBus.$emit("updateGlosasry");
                                        EventBus.$emit("getGlossary");
                                    }
                                };
                                request.onerror = function (event) {
                                    console.log("The data has been written failed. Reason:", event.target.error.message);
                                };
                            });
                        });	
                    }
                };
            };

            self.request.onupgradeneeded = function (event) {
                console.log("The database is upgraded ");
                store.state.db = self.request.result;
                // Create Glossary Table 
                if (!store.state.db.objectStoreNames.contains("GlossaryLibrary")) {
                    var objectStore = store.state.db.createObjectStore("GlossaryLibrary", { key: "localId", autoIncrement: true });
                    objectStore.createIndex("name", "name", { unique: false });
                }
                else {
                    store.state.db.deleteObjectStore(["GlossaryLibrary"]);
                    var objectStore = store.state.db.createObjectStore("GlossaryLibrary", { key: "localId", autoIncrement: true });
                    objectStore.createIndex("name", "name", { unique: false });
                }
            };
        },
    }
};
</script>

<style scoped>
	.gitHash{
		color: #E0F2F1;
		margin: 0;
		font-weight: 600;
		font-size: 11px;
	}
	.powerByDiv{
		display: flex;
		width: 100%;
		height: 50px;
		align-items: flex-end;
	}
	.powerByText{
		color: #E0F2F1;
		margin: 0;
		font-size: 14px;
		font-weight: 600;
		font-family: 'Roboto', sans-serif;
		align-content: bottom
	}
	.powerByArginomeLogo{
		width: 100px;
	}
	.arginomeLogo{
		width: 120px;
	}
	.mpobLogo{
		height: 32px;
	}
	.availableChipDiv{
		display: inline-block;
		align-items: center;
	}
	.availableTickChip{
		display: flex;
		margin: 0 8px;
		color: white;
		background-color: #FF5252;
		border-radius: 50%;
		text-align: center;
		padding: 0 5px;
		width: 18px;
		height: 18px;
		font-size: 8px;
	}
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>

<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.css";

.container{
	padding: 24px 40px;
}
.active{
	color: var(--sidebar-active-color);
	text-decoration: none;
	border: none;
}
a, a:hover, a:visited, a:focus {
	color: white;
    text-decoration:none;
}
@media (min-width: 1400px){
  .container {
      max-width: 97% !important;
  }  
}
.headerBar{
	background-color: var(--main-color) !important;
	z-index: 100 !important;
}
.colorSidebar{
	background-color: #262626 !important;
	display: flex !important;
    flex-direction: column !important;
	justify-content: space-between !important;
	z-index: 200 !important;
}
.availableChip{
	height: 17px;
}

.blackColor{
	color: black !important;
}
.userNameText{
	color: var(--main-color);
}
.userName{
	font-size: 14px;
	margin: 0 0 0 8px;
}
.dropdownIcon{
	font-size: 12px;
}
.black-text{
	color: #000 !important;
}
.searchDiv{
	width: 16%;
	margin: 0rem;
}
.searchField{
	height: 28px;
}
.versionDiv{
	padding: 30px 30px 24px 24px;
}
.myMenuIcon{
	padding-left: 3px;
	font-size: 18px !important;
}
.v-list__group__header:hover{
	background-color: #070707 !important;
}
.sideBarItem a:hover{
	background-color: #070707 !important;
	color: #fff;
}
.primarySideBarTitle{
	font-size: 13.5px;
	font-family: Roboto,sans-serif !important;
}
.secondarySideBarTitle{
	padding-left: 10px;
	font-size: 12px;
	font-family: Roboto,sans-serif !important;
}
.singleSideBarTitle{
	font-size: 13.5px;
	font-family: Roboto,sans-serif !important;
}
.singleSideBarTitle.active{
	color: var(--sidebar-active-color) !important;
}
.secondarySideBarTitle.active{
	color: var(--sidebar-active-color) !important;
}
.singleMenuIcon > .v-icon.active{
	color: var(--sidebar-active-color) !important;
}
.primary--text i{
	color: var(--sidebar-active-color) !important;
}
.menuGroup .v-list__group__header{
	padding-left: 8px;
}
.singleMenuItem a{
	padding-left: 24px;
}
.singleMenuItem a:hover{
	background-color: #070707 !important;
	color: #fff;
}
.v-list__group__header .v-list__group__header__prepend-icon {
	justify-content: center !important;
}
@media(max-width: 500px){
  .searchDiv, .userName, .userNameTextDiv{
      display: none;
  }  
}
/* .content-wrapper {
    display: grid;
    grid-template-columns: 1fr var(--sidebar-info-size);
    overflow: hidden;
} */
</style>


// WEBPACK FOOTER //
// src/components/base.vue